import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {NavigationService_GetFooterDynamicLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.grpc.lazy';
import {useIsInitialLocation} from '@aboutyou/router';
import {useCustomerIsVip} from '@aboutyou/user';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useFooterIdentifier} from './useFooterIdentifier';

export const useFooterDynamicData = () => {
  const isVip = useCustomerIsVip();
  const identifier = useFooterIdentifier();
  const {initialTargetGroup} = useSelectedTargetGroup();
  const isInitialLocation = useIsInitialLocation();

  return useGrpcRequest(
    NavigationService_GetFooterDynamicLazy,
    {
      isVip,
      sessionTargetGroup: initialTargetGroup ?? null,
      identifier: identifier ?? null,
    },
    {
      // The `identifier` & `sessionTargetGroup` is only used for SEO and does not need to ever update on the client. This change makes sure we always use the same cache instance in all places and never redo the request after it was made once.
      transformCacheKey(config) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const {identifier, sessionTargetGroup, ...params} = config.params;
        return {
          ...config,
          params,
        };
      },
      // we only want to fetch the dynamic footer data on direct entry to the page, not on navigation from other pages
      disabled: !isInitialLocation,
      nonEssential: true,
    },
  );
};
